import { Injectable } from '@angular/core';

import { AssertService } from '@connect-services/client/services/assert.service';
import { PaginationSdkParams } from '@connect-services/client/services/fetch-all.service';
import { SortState } from '@connect-services/src/lib/components/table/table.component';
import { defaultPaginationParameters, OrderEnum, PaginationParameters } from '@shared/client/models/pagination.model';

export enum SensitiveSortColumns {
    Description = 'description',
    Email = 'email',
    FamilyName = 'familyName',
    GivenName = 'givenName',
    ImportDate = 'importDate',
    Name = 'name',
}

@Injectable({
    providedIn: 'root',
})
export class TableService {
    public onPaginationChange(
        page: PaginationSdkParams,
        paginationParameters: PaginationParameters,
    ): PaginationParameters {
        return {
            ...paginationParameters,
            page: page.page!,
            take: page.take!,
        };
    }

    public onSortChange(sort: SortState, paginationParameters: PaginationParameters): PaginationParameters {
        const order = sort.order ? sort.order : OrderEnum.ASC;
        const isSensitiveColumn = Object.values(SensitiveSortColumns).includes(sort.orderBy as SensitiveSortColumns);

        AssertService.isEnum<OrderEnum>(order, OrderEnum);

        return {
            ...paginationParameters,
            isCaseSensitive: isSensitiveColumn,
            order: order,
            orderBy: sort.orderBy,
            page: defaultPaginationParameters.page,
        };
    }

    public onSortStateChange(sort: SortState, paginationParameters: PaginationParameters): PaginationParameters {
        const isSensitiveColumn = Object.values(SensitiveSortColumns).includes(sort.orderBy as SensitiveSortColumns);

        return {
            ...paginationParameters,
            isCaseSensitive: isSensitiveColumn,
            order: sort.order ?? OrderEnum.ASC,
            orderBy: sort.orderBy,
            page: defaultPaginationParameters.page,
        };
    }
}
